import { BaseDto } from "@/shared/dtos/base-dto";

export class solicitudes_cita_estado_hist extends BaseDto {
  public id_solicitud: number = 0;
  public id_estado: number = 0;
  public comentario: string = "";
  public cambiado_por_tipo: string = "sistema";
  public cambiado_por_id: number | null = null;
  public created_at: Date | null = null;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
    if (data.created_at) this.created_at = new Date(data.created_at);
  }
}
